import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectBpmnModelerState} from '@ispm-client/modules/bpmn-modeler/store/selectors/bpmn-modeler-state.selector';

const getModelerContext = (state: State): object => state.modelerContext;

export const selectModelerContext: MemoizedSelector<object, object> = createSelector(selectBpmnModelerState, getModelerContext);

